import { FileManagementService } from '@core/services/file-management.service';
import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class AuditTrackerImportCasesHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService, 
               public fileManagementService: FileManagementService
            ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.executeCommandToApi(command, handler);
    return true;
  }

   override downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

}
